export default {
  namespaced: true,
  state: {
    mostrarModalAgendarLlamada: false,
    mostrarModalCalendarioServicios: false,
    idCrmAgendarLlamada: null,
  },
  mutations: {
    setMostrarModalCalendarioServicios(state, valor) {
      state.mostrarModalCalendarioServicios = valor;
    },
    setMostrarModalAgendarLlamada(state, valor) {
      state.mostrarModalAgendarLlamada = valor;
    },
    setIdCrmAgendarLlamada(state, id) {
      state.idCrmAgendarLlamada = id;
    },
  },
  actions: {
    abrirModalAgendarLlamada({ commit }, idCrm) {
      commit('setIdCrmAgendarLlamada', idCrm);
      commit('setMostrarModalAgendarLlamada', true);
    },
  },
};
